import { CustomFontViewMode, displayContent } from 'modules/templateEditor/common';
import styled from 'styled-components';

import { EmptyState } from 'ui/illustrations';
import { H4, WebLink } from 'ui/theme';

const EmptyStateContainer = styled.div`
  align-items: center;
  background-color: #fff;
  border-radius: ${({ theme }) => theme.spacing.values.half};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.utils.pxToRem(70)};
`;

const EmptyStateMessage = styled.p`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  text-align: center;
`;

export const CUSTOM_FONTS_EMPTY_STATE_TEST_ID = 'custom-fonts-empty-state';

export const CustomFontsEmptyState = ({
  setMode,
}: {
  setMode: (value: CustomFontViewMode) => void;
}) => (
  <EmptyStateContainer data-test={CUSTOM_FONTS_EMPTY_STATE_TEST_ID}>
    <EmptyState height={128} width={128} />
    <H4>{displayContent.headerCustomFontsEmpty}</H4>
    <EmptyStateMessage>
      {displayContent.strAddCustomFont}{' '}
      <WebLink onClick={() => setMode(CustomFontViewMode.Create)}>
        {displayContent.linkAddCustomFont}
      </WebLink>
      .
    </EmptyStateMessage>
  </EmptyStateContainer>
);
